import { useEffect, useState } from "react";
import { Archive, ArrowLeft, Eye, Power, RotateCcw } from "lucide-react";
import { Link } from "react-router-dom";
import { api } from "@/auth/AuthContext";
import { TaskDetailDrawer } from "@/pages/ManajemenTask";
import { getTaskDisplayName } from "@/utils/taskDisplay";
import { formatCalendarDate } from "@/utils/dateDisplay";

const fmtDate = (value) => {
  if (!value) return "—";
  try { return new Date(value).toLocaleDateString("id-ID", { day: "2-digit", month: "short", year: "numeric" }); }
  catch { return value; }
};

export default function TaskArchive() {
  const [tasks, setTasks] = useState([]);
  const [detail, setDetail] = useState(null);
  const [notice, setNotice] = useState("");
  const [error, setError] = useState("");
  const [busyId, setBusyId] = useState("");

  const load = async () => {
    try { const response = await api.get("/tasks", { params: { archived: true } }); setTasks(response.data); }
    catch (err) { setError(err.response?.data?.detail || "Gagal memuat Arsip Task."); }
  };
  useEffect(() => { load(); }, []);

  const openDetail = async (task) => {
    setError("");
    try { const response = await api.get(`/tasks/${task.task_id}`); setDetail(response.data); }
    catch (err) { setError(err.response?.data?.detail || "Gagal memuat detail Task."); }
  };

  const changeState = async (task, action) => {
    setBusyId(task.task_id); setError("");
    try {
      await api.post(`/tasks/${task.task_id}/${action}`);
      setNotice(action === "restore" ? "Task dipulihkan ke daftar utama dalam status Ditutup." : "Task dibuka kembali dan dipindahkan ke daftar utama.");
      await load();
    } catch (err) { setError(err.response?.data?.detail || "Status Task gagal diperbarui."); }
    finally { setBusyId(""); }
  };

  return (
    <div className="acct-wrap" data-testid="task-archive-page">
      <div className="acct-head">
        <div><div className="eyebrow"><Archive size={13} /> ARSIP TASK</div><h2 data-testid="task-archive-title">ARSIP TASK</h2><p className="muted-text">Task tetap diperhitungkan dalam performance dan leaderboard Perguruan Tinggi.</p></div>
        <Link to="/kipk/manajemen-task" className="download-button ghost" data-testid="task-archive-back"><ArrowLeft size={14} /> Daftar Task</Link>
      </div>
      {notice && <div className="info-banner" data-testid="task-archive-notice">✓ {notice}</div>}
      {error && <div className="error-banner" data-testid="task-archive-error">{error}</div>}
      <div className="table-wrap">
        <table data-testid="task-archive-table">
          <thead><tr><th>Nama Task</th><th>Jenis</th><th>Deadline</th><th>Diarsipkan</th><th style={{ width: 280 }}>Aksi</th></tr></thead>
          <tbody>
            {tasks.map((task) => <tr key={task.task_id} data-testid={`task-archive-row-${task.task_id}`}>
              <td><strong>{getTaskDisplayName(task)}</strong></td>
              <td><span className={`folder-chip ${task.jenis === "umum" ? "chip-tone-info" : "chip-tone-warn"}`}>{task.jenis === "umum" ? "Umum" : "Khusus"}</span></td>
              <td className="mono" data-testid={`task-archive-deadline-${task.task_id}`}>{formatCalendarDate(task.deadline)}</td>
              <td className="mono">{fmtDate(task.archived_at)}</td>
              <td className="task-row-actions">
                <button className="folder-chip" data-testid={`task-archive-detail-${task.task_id}`} onClick={() => openDetail(task)}><Eye size={11} /> Detail</button>
                <button className="folder-chip" data-testid={`task-restore-${task.task_id}`} disabled={busyId === task.task_id} onClick={() => changeState(task, "restore")}><RotateCcw size={11} /> Pulihkan</button>
                <button className="folder-chip task-open-action" data-testid={`task-archive-open-${task.task_id}`} disabled={busyId === task.task_id} onClick={() => changeState(task, "open")}><Power size={11} /> Buka Kembali</button>
              </td>
            </tr>)}
            {tasks.length === 0 && <tr><td colSpan={5} className="empty-state" data-testid="task-archive-empty">Belum ada Task yang diarsipkan.</td></tr>}
          </tbody>
        </table>
      </div>
      {detail && <TaskDetailDrawer detail={detail} onClose={() => setDetail(null)} onChanged={async () => { setDetail(null); await load(); }} />}
    </div>
  );
}